<template>
  <div
    class="dropdown is-right"
    :class="{ 'is-active': showMenu }"
    @click="toggleMenu"
  >
    <div class="dropdown-trigger">
      <button
        class="button event-menu"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
      >
        <span class="icon is-small">
          <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
        </span>
      </button>
    </div>
    <div class="dropdown-menu" id="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      showMenu: false,
      menuId: Math.random()
        .toString(36)
        .substr(2, 9) // Unique ID for this menu instance
    };
  },
  mounted() {
    // Listen for global menu close events
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("itemMenuToggle", this.handleOtherMenuToggle);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("itemMenuToggle", this.handleOtherMenuToggle);
  },
  methods: {
    toggleMenu(event) {
      event.stopPropagation();

      if (!this.showMenu) {
        // Emit event to close other menus
        const customEvent = new CustomEvent("itemMenuToggle", {
          detail: { menuId: this.menuId }
        });
        document.dispatchEvent(customEvent);
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showMenu = false;
      }
    },
    handleOtherMenuToggle(event) {
      // Close this menu if another menu is being opened
      if (event.detail.menuId !== this.menuId) {
        this.showMenu = false;
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";

button.event-menu {
  width: 50px;
  min-width: 50px;
  height: 50px;
  &:hover {
    border-color: $active-green;
  }
}
</style>
